import * as React from "react";
import { QuoteData } from "@plinknz/tah-website-elements";

export interface BlockQuoteProps {
  data: QuoteData;
}

export const BlockQuote: React.FunctionComponent<BlockQuoteProps> = ({
  data: { text },
}: BlockQuoteProps) => (
  <blockquote className="constrain-width">
    <p>{text}</p>
  </blockquote>
);
